<template>
    <div id="bottom">
        <div class="copyright" style="max-width: 1200px;margin: 0 auto">
          <p class="white t-center mb6">一兮生物技术有限公司</p>
          <div class="flex hcenter vcenter">
            <div class="flex1">
              <div class="flex hcenter vcenter flex-column info">
                <span class="inline-block icon address"></span>
                <span class="mt1 address-color">苏州工业园区东长路88号2.5产业园</span>
              </div>
            </div>
            <div class="border hidden-sm hidden-xs"></div>
            <div class="flex1">
              <div class="flex hcenter vcenter flex-column info">
                <span class="inline-block icon phone"></span>
                <span class="mt1 address-color">0512-62968185</span>
              </div>
            </div>
            <div class="border hidden-sm hidden-xs"></div>
            <div class="flex1">
              <div class="flex hcenter vcenter flex-column info">
                <span class="inline-block icon email"></span>
                <span class="mt1 address-color">office@yixilife.com</span>
              </div>
            </div>
          </div>
          <p class="copyright-color mt6">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color:rgba(255, 255, 255, 0.4)" target="_blank">苏ICP备2022013727号</a>
            ©一兮生物2022-2024</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
  .icon {
    width: 16px;
    height: 16px;
    &.phone {
      background: url('~@/assets/footer/phone.svg') 100% no-repeat;
    }
    &.email {
      background: url('~@/assets/footer/email.svg') 100% no-repeat;
    }
    &.address {
      background: url('~@/assets/footer/address.svg') 100% no-repeat;
    }
  }
  .border {
    width: 1px;
    height: 37px;
    margin: 0 72px;
    border: 1px solid rgba(255, 255, 255, 0.6);
  }
  .address-color {
    color: rgba(255, 255, 255, 0.6)
  }
  .copyright-color {
    color: rgba(255, 255, 255, 0.4)
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue